import {
  portfolioTranslationsBundle,
  Translator,
} from "@fds/wm-typescript-poc-waap-localization-translations";
import { EgbPortfolioStoreModuleFactory } from "@/overrides/EgbPortfolioStoreModuleFactory";
import { portfolioPlugin } from "@fds/wm-typescript-poc-waap-library";
import { formatters } from "@/helpers/formatters";
import {
  LogLevel,
  ConsoleLogger,
  Mdg2Client,
} from "@fds/wm-typescript-mdg2-client";
import store from "@/store";
import { WidgetConfig } from "./index";

const logger = new ConsoleLogger("Portfolio");
logger.setLevel(LogLevel.SILENT);
const fixedTranslations = { ...portfolioTranslationsBundle };
fixedTranslations.de.portfolioHeader.unrealizedPerformance =
  "Unrealisierte Gewinne";
fixedTranslations.de.portfolioHeader.totalPerformance = "Performance";
fixedTranslations.de.portfolio.weightPositionsTitle = "Portfoliogewichtung";
fixedTranslations.de.portfolio.breakdownsTitle = "Portfoliozusammensetzung";
fixedTranslations.de.portfolio.assetClassBreakdownTitle = "Assetklassen";
fixedTranslations.de.portfolio.unrealizedPerformancePositionsTitle =
  "Nicht realisierte Gewinne";
fixedTranslations.de.portfolioPositionsList.unrealizedPerformance =
  "Nicht realisierte GuV";
fixedTranslations.de.portfolioEvaluationChart["1stTrade"] =
  "Seit Portfoliostart";

export default (mdg2Client: Mdg2Client) => {
  return <WidgetConfig>{
    name: portfolioPlugin,
    options: {
      translator: new Translator({
        translations: fixedTranslations,
      }),
      storeModule: new EgbPortfolioStoreModuleFactory({
        mdg2Client,
        logger,
        store,
        options: {
          endpointConfiguration: {
            defaultVersion: "v4",
          },
        },
      }),
      ...formatters,
      logger,
    },
  };
};
